import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { trangThaiHocApi } from "../../../api/category/trangThaiHocApi";
import { rootActions } from "../../actions/rootActions";
import { eTrangThaiHocActionIds } from "../../action-types/category/ITrangThaiHocActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

export function* trangThaiHocSaga(): any {
    yield takeLatest(eTrangThaiHocActionIds.LOAD_START, loadwoker);
}
function* loadwoker (action: any) {
    const response: IBaseResponse = yield call(trangThaiHocApi.SelectAll);
    if (response.is_success)
    {
        yield put(rootActions.category.trangThaiHoc.LOAD_SUCCESS( toLowerCaseDeep(response.data)));
    }
    else {
        yield put(rootActions.category.trangThaiHoc.LOAD_ERROR(response.message ?? "Có lỗi khi tải trạng thái học"));
    }
}